<template>
  <div class="upload">
    <div class="title">上传单个文件，仅限PDF</div>
    <el-upload class="avatar-uploader" :action="action" :show-file-list="false" :before-upload="beforeAvatarUpload">
      <el-button type="danger">导入文件</el-button>
    </el-upload>
    <div v-for="uploadfile in uploadfiles" :key="uploadfile.index">
      <el-input v-model="uploadfile.name" placeholder="请输入数量" style="width: 100%"></el-input>
    </div>
  </div>
</template>

<script>
import CosAuth from '../plugins/cos-auth.min.js'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      action: '',
      uploadfiles: [],
      fileindex: 0
    }
  },
  methods: {
    cleardata () {
      this.uploadfiles = []
      this.fileindex = 0
    },
    beforeAvatarUpload (file) {
      const isPdf = file.type === 'application/pdf'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isPdf) {
        this.$message.error('上传文件只能是 pdf 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }

      if (isPdf && isLt2M) {
        this.apiGetTencentyunCosSts(file)
      }
      return isPdf && isLt2M
    },
    camSafeUrlEncode: function (str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
    },
    apiGetTencentyunCosSts: function (file) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTencentyunCosSts, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            var Key = 'static/' + Vue.prototype.FunGetUUID() + file.name // 这里指定上传目录和文件名
            var auth = CosAuth({
              SecretId: response.data.Tmpsecretid,
              SecretKey: response.data.Tmpsecretkey,
              Method: 'PUT',
              Pathname: '/' + Key
            })

            var XCosSecurityToken = response.data.Sessiontoken
            var url = response.data.Prefix + that.camSafeUrlEncode(Key).replace(/%2F/g, '/')
            var xhr = new XMLHttpRequest()
            xhr.open('PUT', url, true)
            xhr.setRequestHeader('Authorization', auth)
            XCosSecurityToken && xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken)
            xhr.upload.onprogress = function (e) {
              Vue.prototype.FunLogInfo('上传进度 ' + (Math.round(e.loaded / e.total * 10000) / 100) + '%')
            }
            xhr.onload = function () {
              if (/^2\d\d$/.test('' + xhr.status)) {
                // var ETag = xhr.getResponseHeader('etag');
                that.uploadfiles = []
                that.uploadfiles.push({ name: file.name, url: url, index: 0 })
                that.$emit('change', url)
              } else {
                Vue.prototype.FunLogInfo('文件 ' + Key + ' 上传失败，状态码：' + xhr.status)
              }
            }
            xhr.onerror = function () {
              Vue.prototype.FunLogInfo('文件 ' + Key + ' 上传失败，请检查是否没配置 CORS 跨域规则')
            }
            xhr.send(file)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
  display: inline-block;
}
// /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
// }
// /deep/ .el-upload:hover {
//     border-color: #409EFF;
// }

.upload{
    display: inline-block;
    margin-left: 10px;
}
</style>
